import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IBookingResponse } from "../../Orchestrator/Types/Types/BookingTypes";

export async function patchBookingPromotionCodes(bookingId: string, promotionCodes: string[]): Promise<IApiResponse<IBookingResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.patchBooking}/${bookingId}`;
    return await apiRequest<IBookingResponse>(endpoint, 'PATCH', {
        body: JSON.stringify({
            promotionCodes: promotionCodes.map(code => ({ code })),
            corporateCodes: []
        })
    });
}
